/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import moment from "moment";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import customModal from "../customModal/customModal.vue";

export default {
    name: "ChangeCycleStatusPopUp",
    components: {
        customModal,
        VPagination
    },
    emits: ["closeModal"],
    props: {
        patientid: {
            type: String,
            default: null,
        },
        cycleid: {
            type: Number,
            default: null,
        },
        occurrence: {
            type: Number,
            default: null,
        }
    },

    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            token: "",
            studyId: "",
            studyVersion: "",
            loading: false,
            cycleStatusOptions: [],
            selectedStatus: ""

        };
    },

    created() {
        this.token = store.getters.getIdToken;
        this.studyId = store.getters.getStudyIs;
        this.studyVersion = store.getters.getStudyVersion;
    },
    async mounted() {
        this.loadExistingStatus(this.cycleid, this.occurrence, this.patientid);
        this.loadStatusOptions();

    },

    methods: {

        async loadExistingStatus(cycleId, occurrence, patientId) {

            try {
                const response = await axios.get(
                    // `https://localhost:54930/cycle/getcurrentcyclestatus?cycleId=${cycleId}&occurrence=${occurrence}&patientId=${patientId}`,
                    `${this.baseurl}/management/cycle/getcurrentcyclestatus?cycleId=${cycleId}&occurrence=${occurrence}&patientId=${patientId}`,
                    {
                        headers: {
                            Authorization: "Bearer " + this.token,
                            "Content-Type": "application/json",
                        },
                    }
                );
                this.selectedStatus = response.data;
                console.log("Fetched existing cycle status response:", response.data);
            } catch (err) {
                console.error("Failed to load existing cycle status:", err);
            }
        },
        async updateCycleStatus() {
            
            try {
                await axios.put(
                    `${this.baseurl}/management/cycle/updatecyclestatus?cycleId=${this.cycleid}&occurrence=${this.occurrence}&patientId=${this.patientid}&newStatus=${this.selectedStatus}`,{},
                    {
                        headers: {
                            Authorization: "Bearer " + this.token,
                            "Content-Type": "application/json",
                        },
                    }
                );
                this.closeModal();
            } catch (err) {
                console.error("Failed to update cycle status:", err);
            }
        },
        async loadStatusOptions() {
            try {
                const response = await axios.get(
                    `${this.baseurl}/management/cycle/cyclestatuslist`,
                    {
                        headers: {
                            Authorization: "Bearer " + this.token,
                            "Content-Type": "application/json",
                        },
                    }
                );
                this.cycleStatusOptions = response.data;
                console.log("Fetched cycle status options response:", response.data);
            } catch (err) {
                console.error("Failed to load cycle status options:", err);
            }
        },

        closeModal() {
            this.$emit("closeModal");
        },

    }
};
